import { ProcessingStatus, TeamAssignment } from 'features/orderManagement/enum';

// ANS-916: reassigning a file no longer always resets the status to "New" - moving a file back
// toward the team that sent it returns it to that team's queue instead.
const statusByTeamMove: Partial<Record<TeamAssignment, Partial<Record<TeamAssignment, ProcessingStatus>>>> = {
  [TeamAssignment.IFSC]: {
    [TeamAssignment.PFSC]: ProcessingStatus.New,
  },
  [TeamAssignment.PFSC]: {
    [TeamAssignment.CRS]: ProcessingStatus.New,
    [TeamAssignment.IFSC]: ProcessingStatus['Returned To Queue'],
  },
  [TeamAssignment.CRS]: {
    [TeamAssignment.PFSC]: ProcessingStatus['Returned To Queue'],
  },
};

// ANS-916: IFSC and CRS never hand files directly to each other, so the other one is not offered.
const hiddenTeamByFileTeam: Partial<Record<TeamAssignment, TeamAssignment>> = {
  [TeamAssignment.IFSC]: TeamAssignment.CRS,
  [TeamAssignment.CRS]: TeamAssignment.IFSC,
};

/**
 * The status a file defaults to when it moves from one team to another. Pairings the business
 * has not defined - and a selection made against a mixed set of files - fall back to "New",
 * which is what every reassignment used to produce.
 */
export function getStatusForTeamMove(
  fromTeam: TeamAssignment | null | undefined,
  toTeam: TeamAssignment | null | undefined,
): ProcessingStatus {
  if (!fromTeam || !toTeam) {
    return ProcessingStatus.New;
  }
  return statusByTeamMove[fromTeam]?.[toTeam] ?? ProcessingStatus.New;
}

/**
 * Whether a team can be offered as a destination for a file currently assigned to `fileTeam`.
 * A mixed selection has no single origin team, so nothing is filtered out.
 */
export function isTeamSelectable(fileTeam: TeamAssignment | null | undefined, team: TeamAssignment): boolean {
  return !fileTeam || hiddenTeamByFileTeam[fileTeam] !== team;
}
